export default {
  list: [
    {
      title: 'در انتظار',
      value: 'PENDING'
    },
    {
      title: 'فعال',
      value: 'CONFIRMED'
    },
    {
      title: 'غیرفعال',
      value: 'DISABLED'
    }
  ],
  values: {
    PENDING: 'PENDING',
    CONFIRMED: 'CONFIRMED',
    DISABLED: 'DISABLED'
  }
};
